import React from 'react'
import GAUsersContainer from '../../modules/GAUsers/containers/GAUsersContainer/GAUsersContainer'

const GAUsers = () => {
  return (
    <GAUsersContainer />
  )
}

export default GAUsers